import { EntBasicHB } from "../handBooks/basicHB";
import { EntUnitMeasurement } from "../handBooks/unitMeasurement";
import { EntDirection } from "../handBooks/direction";

export class EntGrossProductCollection {
  id: number|null = null;
  year: number|null = null;
  region?: EntUnitMeasurement|null = null;
  farmCategory?: EntBasicHB|null = null;
  productType?: EntProductType|null = null;
  unitMeasurement?: EntUnitMeasurement|null = null;
  amount: number|null = null;

  regionId?: number|null = null;
  farmCategoryId?: number|null = null;
  productTypeId?: number|null = null;
  unitMeasurementId?: number|null = null;
}

export class EntProductType {
  id: number|null = null;
  nameRu: string|null = null;
  nameKy: string|null = null;
  unitMeasurement: EntUnitMeasurement|null = null;
  directions: EntDirection|null = null;
}